import React from 'react';
import {PriorityIcon} from '@priority-software/priority-style-react';
import {HoveringZoomButton} from './HoveringZoomButton';
import {ZoomTypes} from '../consts/zoomTypes';
import {MoreInfoTrigger} from '../../../features/MoreInfo/MoreInfoTrigger';
import {isRTL} from '../../../Localization';
import {getLocalizedText, texts} from '../../../constants/TextConst';
import styles from '../styles/FieldSearch.module.scss';

interface IFormInputBtnsWrapperProps {
    elementRect: DOMRect;
    showZoomBtn: boolean;
    showMoreInfoBtn: boolean;
    handleZoom: (arg: string) => void;
    zoomtype: number;
    fieldName: string;
}

export const FormInputBtnsWrapper: React.FC<IFormInputBtnsWrapperProps> = ({
    elementRect,
    showZoomBtn,
    showMoreInfoBtn,
    handleZoom,
    zoomtype,
    fieldName
}) => {
    const numOfBtns = showZoomBtn && showMoreInfoBtn ? 2 : 1;
    const width = elementRect.height * numOfBtns;

    const componentStyle = generateStyle(elementRect, width);

    function generateStyle(element, width) {
        const isRtl = isRTL();
        const scrollbarWidth = 25;
        const elementHeight = element.bottom - element.top;
        const elementWidth = element.right - element.left;
        let borderStyle;
        let position;
        let topPosition;
        let revertPosition = false;
        const borderWidth = 1;
        let flexDirection;
        if (
            (isRtl && element.left < width + scrollbarWidth) ||
            (!isRtl && element.right > window.innerWidth - width - scrollbarWidth)
        ) {
            revertPosition = true;
        }
        if (revertPosition) {
            borderStyle = isRtl ? {borderLeft: 'none'} : {borderRight: 'none'};
            position = isRtl
                ? {left: elementWidth - (numOfBtns - 2 * borderWidth)}
                : {right: elementWidth - (numOfBtns - 2 * borderWidth)};
            flexDirection = 'row-reverse';
        } else {
            borderStyle = isRtl ? {borderRight: 'none'} : {borderLeft: 'none'};
            position = isRtl ? {right: numOfBtns - borderWidth} : {left: numOfBtns - borderWidth};
        }

        return {
            wrapperStyle: {
                width,
                ...topPosition,
                ...position,
                flexDirection,
                height: elementHeight
            },
            middleBtnStyle: {
                ...borderStyle
            }
        };
    }

    return (
        <div className={styles.btnsWrapper} style={componentStyle.wrapperStyle}>
            {showZoomBtn && (
                <HoveringZoomButton
                    onZoom={() => handleZoom('Zoom (Icon)')}
                    tooltip={getLocalizedText(texts.zoomButtonAlt)}
                    icon={zoomtype === ZoomTypes.Zoom ? PriorityIcon.searchThin : PriorityIcon.zoom}
                    borderStyle={componentStyle.middleBtnStyle}
                />
            )}
            {showMoreInfoBtn && (
                <MoreInfoTrigger
                    fieldName={fieldName}
                    borderStyle={componentStyle.middleBtnStyle}
                />
            )}
        </div>
    );
};
